// extracted by mini-css-extract-plugin
export default {"component":"BWClientHeader_component__oUeTf","profilePronouns":"BWClientHeader_profilePronouns__jTOx0"};